import React, { useContext } from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";
import SemestersContext from "./contexts/SemestersContext";

export function SemesterSwitcher() {
  const { currentSemester, semesters, teachingSemesters } =
    useContext(SemestersContext);

  const combinedSemesters = [
    ...semesters.map(extractSemesterInfo),
    ...teachingSemesters.map(extractSemesterInfo),
  ]
    .filter((value, index, array) => {
      return index === array.findIndex((s) => s.termId === value.termId);
    })
    .sort((a, b) => b.termId - a.termId);

  const indexOf = combinedSemesters.findIndex(
    (sem) => sem.termId === currentSemester.termId
  );

  if (indexOf !== -1) {
    const previousSemester = combinedSemesters[indexOf + 1];
    const nextSemester = combinedSemesters[indexOf - 1];

    return (
      <SwitcherStyles>
        {previousSemester ? (
          <Link
            to={`/academics/semester/${previousSemester.slug}`}
            className="prev-arrow"
          >
            Prev Semester
          </Link>
        ) : (
          <span className="prev-arrow">Prev Semester</span>
        )}

        <span> | </span>

        {nextSemester ? (
          <Link
            to={`/academics/semester/${nextSemester.slug}`}
            className="next-arrow"
          >
            Next Semester
          </Link>
        ) : (
          <span className="next-arrow">Next Semester</span>
        )}
      </SwitcherStyles>
    );
  }

  return null;
}
SemesterSwitcher.displayName = "SemesterSwitcher";

const SwitcherStyles = styled.div`
  color: var(--dusty-gray);
  font-size: 11px;
  text-transform: uppercase;

  padding: 0 9px;
  margin-right: 15px;

  .next-arrow,
  .prev-arrow {
    position: relative;

    &::before {
      border-bottom: 4px solid transparent;
      border-top: 4px solid transparent;
      content: "";
      height: 0;
      position: absolute;
      top: 2px;
      width: 0;
    }
  }

  .next-arrow::before {
    border-left: 4px solid var(--dusty-gray);
    right: -8px;
  }
  .prev-arrow::before {
    border-right: 4px solid var(--dusty-gray);
    left: -8px;
  }

  a.next-arrow::before {
    border-left: 4px solid var(--denim);
  }
  a.prev-arrow::before {
    border-right: 4px solid var(--denim);
  }
`;

const extractSemesterInfo = (sem) => ({
  termId: sem.termId,
  slug: sem.slug,
});
